import * as React from 'react';

/**
 * The activity an entry belongs to, linked to its detail page.
 *
 * Print preview renders it as plain text: the printed output is read on paper,
 * where a link is dead weight, and the preview is generated for users who may
 * not be able to open the target.
 */
export default function ActivityTitle({ activity, isPrintPreview }) {
    if (!activity || !activity.id) {
        return null;
    }
    if (isPrintPreview) {
        return <span className="activity_title mr ml">{activity.title}</span>;
    }
    return (
        <a href={`/gad?actId=${activity.id}`} className="activity_title mr ml" title={activity.title}>
            {activity.title}
        </a>
    );
}
